@if (order) {
  <div>
    @if (!order.id) {
      <dx-button text="{{ 'CREATE_ORDER' | translate }}" [useSubmitBehavior]="true" class="btn me-2" icon="mdi mdi-folder-plus"></dx-button>
    }
    @if (order.id) {
      <dx-button
        text="{{ 'SAVE' | translate }}"
        [disabled]="!isChanged()"
        [useSubmitBehavior]="true"
        icon="mdi mdi-content-save"
        class="btn me-2"></dx-button>
    }
    <dx-button text="{{ 'CLOSE' | translate }}" (onClick)="close()" class="btn me-2 btn-light"></dx-button>
  </div>
}
